module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/wfft_2x.438e74f.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/wfft_2x.png
// module id = qzVD
// module chunks = 41